import { Record } from '@sinclair/typebox';
import { BudgetPurpose } from '../../graphql/generated';
import styleguide from '../../styleguide';

const FIXED_COLOR = styleguide.colors.greenDarker;
const LIFESTYLE_COLOR = styleguide.colors.indigo;
const SAVING_INVESTING_COLOR = styleguide.colors.blue;

export const BUDGET_PURPOSE_COLOR_MAP: Record<
    Exclude<BudgetPurpose, 'income'>,
    string
> = {
    fixed: FIXED_COLOR,
    lifestyle: LIFESTYLE_COLOR,
    saving_investing: SAVING_INVESTING_COLOR,
};
